import { useState, useEffect } from 'react';
import { firestore, storage } from '../firebase';
import { ref, uploadBytesResumable, getDownloadURL } from '@firebase/storage';
import { doc, setDoc, serverTimestamp } from '@firebase/firestore';

const useFileUpload = (file, uploadFor, userID) => {
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);
  const [url, setUrl] = useState(null);
  const [pathname, setPathname] = useState(null);

  useEffect(() => {
    // references
    setError(null);
    const storageRef = ref(storage, `${uploadFor}/${userID}/${file.name}`);
    const documentRef = doc(firestore, "User", userID, "Documents", `${uploadFor}`);
    
    uploadBytesResumable(storageRef, file).on('state_changed', (snap) => {
      let percentage = (snap.bytesTransferred / snap.totalBytes) * 100;
      setProgress(percentage);
    }, (err) => {
      setError("Something went wrong");
    }, async () => {
      const url = await getDownloadURL(storageRef);
      const createdAt = serverTimestamp();
      const filePath = storageRef.fullPath;
      await setDoc(documentRef, {url, createdAt, filePath});
      setUrl(url);
      setPathname(filePath);
    });
  }, [file, uploadFor, userID]);

  return { progress, url, pathname, error };
}

export default useFileUpload;